import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WsSyncConfigRepository } from '../../domain/repositories/ws-sync-config.repository';
import { WsSyncActiveItem, WsSyncToggleCommand } from '../../domain/interfaces/ws-sync-state.types';
import { WsSyncApiService } from '../services/ws-sync-api.service';

@Injectable({ providedIn: 'root' })
export class WsSyncConfigRepositoryImpl extends WsSyncConfigRepository {
  private readonly apiService = inject(WsSyncApiService);

  override toggleSync(command: WsSyncToggleCommand): Observable<void> {
    return this.apiService.synchronize(command).pipe(map(() => void 0));
  }

  override listActive(): Observable<WsSyncActiveItem[]> {
    return this.apiService.listActive();
  }
}

export const WsSyncConfigRepositoryProvider = {
  provide: WsSyncConfigRepository,
  useExisting: WsSyncConfigRepositoryImpl,
};
